(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name manageFlight.controller:ManageFlightCtrl
     *
     * @description
     *
     */
    angular
        .module('manageFlight')
        .directive('focusOn',function($timeout) {
			return {
				restrict : 'A',
				link : function(vm,$element,$attr) {
					vm.$watch($attr.focusOn,function(_focusVal) {
						$timeout(function() {
							_focusVal ? $element[0].focus() : $element[0].blur();
						});
					});
				}
			}
		})
        .controller('ManageFlightCtrl', ManageFlightCtrl);

    function ManageFlightCtrl(applicationConstants, CommonMasterData, CommonLogicService, ManageFlightService,
                              EventManagerService, FlightWatch, PopupManager, MessageService,TrainingProgramsService) {
        var vm = this;
        vm.ctrlName = 'ManageFlightCtrl';

        vm.model = {
            searchPanelToggle: true,
            searchCriteria: {
                flightNumber:{value:"", required:true},
                aircraftModel: ManageFlightService.getDefaultAircraftType(),
                flightStatus: {flightStatusCode: 'SCH', flightStatusDesc: 'SCH'},
                from: {value:ManageFlightService.getDefaultLocation(), required:true},
                to: {value:ManageFlightService.getDefaultLocation(), required:true},
                fromDate: moment(new Date()).format('DD/MM/YYYY'),
                toDate: moment(new Date()).format('DD/MM/YYYY')
            },
            masterList: {
                airportList: [],
                aircraftList: [],
                flightStatusList: [],
                flightModes: [],
                displayWeekdays: CommonLogicService.getDayOfWeeks(),
                delayCodeDetails:[],
                fuelSuppliers:[],
                acCapacities : [],
                acModelList : [],
                operationTypes : []
            },
            manageFlightList: [],
            initialSearchDone: false,
            selectedFlight: null,
            isElasticLoadingVisible:false,
            editorMode: applicationConstants.EDITOR_STATUS.ADD,
            showFlightExportButton : false
        };
        //for feet watch popup
        vm.popUpDetails = {};
        vm.popUpDetails.airCraftDetails = '';
        vm.popUpDetails.relatedAirCraft = '';
        vm.popUpDetails.approachTypes = '';

//        EventManagerService.registerEventListener(EventManagerService.EVENT.DO_ELASTIC_SEARCH, getNextSetOfRecords);

        vm.clickOnSearch = function () {
            vm.model.initialSearchDone = false;
            vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
        };

        vm.searchFlights = function (searchParams) {
            vm.model.manageFlightList = [];
            vm.model.searchCriteria = searchParams;
            vm.model.searchCriteria.pageSize = 10000;
            vm.model.searchCriteria.startPosition = 1;
            searchFlights();
        };

        vm.selectAFlight = function (selectedFlight) {
            vm.model.selectedFlight = ManageFlightService.getSelectedFlightForEditor(selectedFlight);
            vm.model.editorMode = applicationConstants.EDITOR_STATUS.EDIT;
            setWeekDays();
            setModelCapacityListByAcModel();
        };

        vm.createNewFlight = function () {
            vm.model.selectedFlight = ManageFlightService.getSelectedFlightForEditor(null);
            vm.model.editorMode = applicationConstants.EDITOR_STATUS.ADD;
            setWeekDays();
            setModelCapacityListByAcModel();
        };

        vm.changeCriteria = function () {
            if (vm.model.initialSearchDone === true) {
                vm.model.manageFlightList = ManageFlightService.refineFlightData(vm.model.searchCriteria);
            }
        };

        vm.changeEditorField = function (flag) {
            if(flag==='fromAirport' || flag === 'toAirport'){
                validateAirportCode();
            }
        };

      function setWeekDays(){
        	vm.model.masterList.displayWeekdays = CommonLogicService.getDayOfWeeks();
        	var days = getAvailableDaysInGivenRange(vm.model.selectedFlight.fromDate, vm.model.selectedFlight.toDate);
        	if(days.length > 0){
        		var allSelected = true;
        		angular.forEach(vm.model.masterList.displayWeekdays, function (day) {
    				if(days.indexOf(day.name) !== -1){
    					day.selected = true;
    					day.editable = true;
    				} else if (day.name == 'All'){
    					day.editable = true;
    				} else {
    					day.editable = false;
    				}
                });

        		setAllSelected();
        	}
        }

        function setAllSelected(){
        	var allSelected = true;
        	angular.forEach(vm.model.masterList.displayWeekdays, function (day) {
				if (day.name != 'All' && day.editable && !day.selected){
					allSelected = false;
				}
            });

        	if(allSelected){
    			var found = vm.model.masterList.displayWeekdays.find(function(dow) {
    				  return (dow.name == 'All');
    				});
    			if(!!found){
    				found.selected = true;
    			}
    		}
        }

        function getAvailableDaysInGivenRange(fromDate, toDate) {
           var days = [];
           if(!!fromDate && !!toDate){
        	   var startDate = moment(fromDate, 'DD/MM/YYYY');
               var endDate = moment(toDate, 'DD/MM/YYYY');
               var count = 0;
               while ((startDate.isBefore(endDate) || startDate.isSame(endDate)) && count < 7) {
            	   days.push(startDate.format('dddd'));
                   startDate.add(1, 'days');
                   count++;
               }
           }
            return days;
        }

        function validateAirportCode() {
            if(vm.model.selectedFlight.from!==null && vm.model.selectedFlight.to!==null){
                if(vm.model.selectedFlight.from.airPortCode === vm.model.selectedFlight.to.airPortCode){
                 //   MessageService.error('Airport selection invalid');
                    return true;
                }else{
                    return true;
                }
            }else{
                return true;
            }
        }

        vm.changeSearchCriteria = function (formModel, flag) {
          if(flag==='flightNumber'){
              if(vm.model.searchCriteria.flightNumber.value){
                vm.model.searchCriteria.from.required=false;
                vm.model.searchCriteria.to.required=false;

                if(!(vm.model.searchCriteria.from.value && vm.model.searchCriteria.to.value)){
                    vm.model.searchCriteria.from.value = undefined;
                    vm.model.searchCriteria.to.value = undefined;
                }
              } else {
                  vm.model.searchCriteria.from.required=true;
                  vm.model.searchCriteria.to.required=true;
              }
          }

          if(flag==='from') {
              if (vm.model.searchCriteria.from.value) {
                vm.model.searchCriteria.flightNumber.required = false;
                if(vm.model.searchCriteria.to.value){
                  vm.model.searchCriteria.to.required = false;
                } else {
                  vm.model.searchCriteria.to.required = true;
                }
              } else if(vm.model.searchCriteria.flightNumber.value){
                vm.model.searchCriteria.flightNumber.required = false;
                vm.model.searchCriteria.from.required=false;
                vm.model.searchCriteria.to.required=false;

                if(!(vm.model.searchCriteria.from.value && vm.model.searchCriteria.to.value)){
                  vm.model.searchCriteria.from.value = undefined;
                  vm.model.searchCriteria.to.value = undefined;
                }
              } else {
                vm.model.searchCriteria.flightNumber.required = true;
                vm.model.searchCriteria.from.required=true;
                vm.model.searchCriteria.to.required=true;
              }
          }

          if(flag==='to') {
            if (vm.model.searchCriteria.to.value) {
              vm.model.searchCriteria.flightNumber.required = false;
              if(vm.model.searchCriteria.from.value){
                vm.model.searchCriteria.from.required = false;
              } else {
                vm.model.searchCriteria.from.required = true;
              }
            } else if(vm.model.searchCriteria.flightNumber.value){
              vm.model.searchCriteria.flightNumber.required = false;
              vm.model.searchCriteria.from.required=false;
              vm.model.searchCriteria.to.required=false;

              if(!(vm.model.searchCriteria.from.value && vm.model.searchCriteria.to.value)){
                vm.model.searchCriteria.from.value = undefined;
                vm.model.searchCriteria.to.value = undefined;
              }
            } else {
              vm.model.searchCriteria.flightNumber.required = true;
              vm.model.searchCriteria.from.required=true;
              vm.model.searchCriteria.to.required=true;
            }
          }

          if(flag === 'fromDate'){
            var tempFromDate = moment(vm.model.searchCriteria.fromDate, "DD/MM/YYYY").endOf('month').format("DD/MM/YYYY");
            if (tempFromDate != undefined && tempFromDate.toUpperCase() != "INVALID DATE") {
              vm.model.searchCriteria.toDate = tempFromDate;
            }
          }

        };

        vm.changeEditorField = function(flag){

        	if(flag == 'fromDate' || flag == 'toDate'){
        		if(flag == 'fromDate' && !!vm.model.selectedFlight.fromDate &&
        				( (!vm.model.selectedFlight.toDate
        						|| isFromDateAfterToDate(vm.model.selectedFlight.fromDate, vm.model.selectedFlight.toDate)))
              && vm.model.selectedFlight.fromDate.length>=10){
        			vm.model.selectedFlight.toDate = angular.copy(vm.model.selectedFlight.fromDate);
        		} else if(flag == 'toDate' && !!vm.model.selectedFlight.toDate &&
        				( (!vm.model.selectedFlight.fromDate
        						|| isFromDateAfterToDate(vm.model.selectedFlight.fromDate, vm.model.selectedFlight.toDate)))
              && vm.model.selectedFlight.toDate.length>=10){
        			vm.model.selectedFlight.fromDate = angular.copy(vm.model.selectedFlight.toDate);
        		}
        		setWeekDays();
        	} else if(flag == 'acModel'){
        		setModelCapacityListByAcModel();
        	}
        }

        function setModelCapacityListByAcModel(resetCapacity){
        	var modelNumber = null;
        	if(!!vm.model.selectedFlight.aircraftModel && !!vm.model.selectedFlight.aircraftModel.modelNumber){
        		modelNumber = vm.model.selectedFlight.aircraftModel.modelNumber;
        	}
        	vm.model.masterList.acCapacities = getModelCapacitiesByModel(modelNumber);
        	if(!modelNumber){
        		vm.model.selectedFlight.acModelCapacity = null;
        	} else if(vm.model.masterList.acCapacities.length == 1){
        		vm.model.selectedFlight.acModelCapacity = vm.model.masterList.acCapacities[0];
        	}
        }

        function getModelCapacitiesByModel(acModelNumber){
        	var modelCapacities = [];
        	if(!!acModelNumber){
        		modelCapacities = _.filter (vm.model.masterList.acModelList, function(acModel) {
        		    return (acModel.airCraftType.trim() == acModelNumber.trim());
        		});
        	}
        	return modelCapacities;
        }

        function isFromDateAfterToDate(fromDate, toDate){
        	if(!!fromDate && !!toDate){
         	   	var startDate = moment(fromDate, 'DD/MM/YYYY');
                var endDate = moment(toDate, 'DD/MM/YYYY');
                return startDate.isAfter(endDate)
            }
        	return true;
        }

        vm.submitFlight = function (action, selectedItem) {
            if (action === applicationConstants.EDITOR_STATUS.DELETE){
                deleteFlight(selectedItem);
            }else if(action === applicationConstants.EDITOR_STATUS.EDIT){
                editFlight(selectedItem);
            }else{
                saveFlight(selectedItem);
            }
        };

        function deleteFlight(selectedFL) {
            //TODO Delete
        }

        function editFlight(selectedFL) {
            var editFlightInfo = ManageFlightService.getFlightInfoForEdit(selectedFL);
            if(editFlightInfo.flightLegId!==null){
                FlightWatch.getAirCraftDetails(editFlightInfo.flightLegId,
                    function (response) {
                        vm.popUpDetails.airCraftDetails = response.flightDetResponceDto;
                        vm.popUpDetails.fuelSuppliers = vm.model.masterList.fuelSuppliers;
                        vm.popUpDetails.airports = vm.model.masterList.airportList;
                        vm.popUpDetails.delayCodeDetails = response.delayCodeAdaptDTOs;
                        vm.popUpDetails.updateFlightSource = applicationConstants.UPDATE_FLIGHT_SOURCE.MANAGE_FLIGHT;
                        FlightWatch.loadAircraftListByCode(editFlightInfo.aircraftModel,
                            function (response) {
                                vm.popUpDetails.relatedAirCraft = response;
                                CommonMasterData.approachTypes(
                                    function (response) {
                                        vm.popUpDetails.approachTypes = response;
                                        PopupManager.openModal('FLIGHT_UPDATE_POPUP', vm.popUpDetails, updateFlightRotationData);
                                    }, function () {}
                                );
                            },
                            function () {
                                console.log('Open Flight search retrieval error');
                            })

                    },
                    function (response) {}
                );
            }

        }

        function updateFlightRotationData(param) {
            if (param) {
              vm.model.manageFlightList = [];
              vm.model.searchCriteria.pageSize = 40;
              vm.model.searchCriteria.startPosition = 1;
              searchFlights();

              vm.createNewFlight();
            }
        }

        function saveFlight(selectedFL) {
            //Save
            if(validateAirportCode()){
                var lsItems = vm.model.masterList.displayWeekdays;
                ManageFlightService.saveManageFlight(selectedFL, lsItems,
                    function(response){
                        if(response.success){
                            MessageService.success(MessageService.MESSAGES.COMMON.SUCCESS_SAVED);
                            vm.createNewFlight();
                            updateSearchCriteria(selectedFL);
                            searchFlights();
                        }
                    },
                    function(error){
                        MessageService.error(error.msg[0]);
                    }
                );
            }
        }

        function updateSearchCriteria(selectedFL) {
        	  vm.model.searchCriteria.flightNumber.value = selectedFL.flightNo;
            vm.model.searchCriteria.from.value = selectedFL.from;
            vm.model.searchCriteria.to.value = selectedFL.to;
            vm.model.searchCriteria.pageSize = 40;
            vm.model.searchCriteria.startPosition = 1;
        }

        function getNextSetOfRecords() {
            vm.model.searchCriteria.startPosition = vm.model.searchCriteria.startPosition + vm.model.searchCriteria.pageSize;
            vm.model.isElasticLoadingVisible = true;
            searchFlights()
        }

        function searchFlights() {

        	vm.model.showFlightExportButton = false;

            ManageFlightService.setSearchCriteria(vm.model.searchCriteria, function (flightList) {
                angular.forEach(flightList, function (flight) {
                    vm.model.manageFlightList.push(flight);
                });
                vm.model.searchPanelToggle = false;
                vm.model.isElasticLoadingVisible= false;
                vm.model.initialSearchDone = true;

                if(vm.model.manageFlightList.length > 0){
                	 vm.model.showFlightExportButton = true;
                }

            });
        }


        vm.exportFlightData = function(){

        	var exportData = getExportData();

        	var flightData =  alasql("SELECT " +
        	 		"[recNumber] as [#], [flightNumber] as [Flight Number], " +
        	 		"[acType] as [A/C Type], [from] as [From], [to] as [To]," +
        	 		"[etd] as [ETD], [eta] as [ETA]," +
        	 		"[mode] as [Mode] FROM ? ", [exportData]);

        	var opts = [{sheetid:'Flight Schedule',header:true}];

        	alasql("SELECT * INTO XLSX('flight_schedule.xlsx',?) FROM ? ", [opts,[flightData]]);

        }

        function getExportData(){

        	var exportData = [];

        	if(vm.model.manageFlightList == null || vm.model.manageFlightList.length == 0){
        		return exportData;
        	}

        	var i = 0;
        	angular.forEach(vm.model.manageFlightList, function (flight) {

        		var etd =  flight.estimatedDepartureDate + " "+ flight.estimatedDepartureTime;
        		var eta =  flight.estimatedArrivalDate + " "+ flight.estimatedArrivalTime;
        		var mode = (flight.flightMode == null || flight.flightMode == '' ) ? '' : flight.flightMode;

        		exportData.push({
        			"recNumber":++i,
        			"flightNumber":flight.flightNo,
        			"acType":flight.modelNo,
        			"from":flight.origin,
        			"to":flight.destination,
        			"etd":etd,
        			"eta":eta,
        			"mode":mode
        		});
            });

        	return exportData;

        }

        (function(){

			CommonMasterData.getAircraftModels(function(airCraftList) {
				var aircrafts = TrainingProgramsService.setAirCraftTypes(airCraftList);
				ManageFlightService.setAirCrafts(aircrafts);
				vm.model.masterList.aircraftList = aircrafts;
			}, function(error) {
			});

      CommonMasterData.getFlightStatusList(function(flightStatusList) {
        vm.model.masterList.flightStatusList = flightStatusList;
      }, function(error) {
        console.log('Flight Status List retrieval error!!!');
      });

			 CommonMasterData.getAircraftTypeList(function(acModelList) {
				 //set all models in ManageFlightService cache
				ManageFlightService.setAcModels(acModelList);
				vm.model.masterList.acModelList = ManageFlightService
						.getAcModels();
			}, function() {
			});

            CommonMasterData.getAirportList(function (airportList) {
                ManageFlightService.setAirports(airportList);
                vm.model.masterList.airportList = ManageFlightService.getAirports();
            }, function (error) {})

            CommonMasterData.getDelayCodeDetails(function (response) {
                    vm.model.masterList.delayCodeDetails = response.delayCodeAdaptDTOs;
                }, function () {});
            CommonMasterData.getFlightOperationTypes(function (response) {
              vm.model.masterList.operationTypes = response;
            }, function () {} );
            vm.model.masterList.flightModes = ManageFlightService.flightModesMasterList();
            vm.model.selectedFlight = ManageFlightService.getSelectedFlightForEditor(null);

        })();
    }
}());
